export class MedicineOverviewContentModel {
    public medicineId: number;
    public langId: number;
    public overviewSummary: string;
    public overviewAboutMedicine: string;
    public overviewBeforeIntake: string;
    public overviewDosage: string;
    public overviewSideEffects: string;
    public overviewSafetyData: string;
    public overviewAdditionalInfo: string;
    public fullDescription: string;
}